import React from "react";
import moment from "moment";
import NullableValue from "../../../../../../../Utils/renderField/nullableValue";
import { RenderNumber } from "../../../../../../../Utils/renderField/renderReadField";

// Pallets de una fila de un cierre ya cerrado: la foto del corte, con las pacas
// antes y después del conteo en los pallets que se reajustaron
export const PacasCierreCerradoTable = ({ lineas }) => (
    <div className="new-table-wrapper">
        <table className="table-striped">
            <thead>
                <tr>
                    <th>No. de pallet</th>
                    <th>Identificador físico</th>
                    <th>Pacas registradas</th>
                    <th>Pacas reales</th>
                    <th>Diferencia</th>
                    <th>Observaciones</th>
                    <th>Responsable reajuste</th>
                </tr>
            </thead>
            <tbody>
                {lineas.length === 0 && (
                    <tr>
                        <td colSpan={7} className="text-center">
                            No hay pallets con existencia de este producto y
                            condición
                        </td>
                    </tr>
                )}
                {lineas.map((linea) => {
                    // negativa cuando al pallet le faltaban pacas contra lo
                    // que el sistema tenía registrado
                    const diferencia =
                        Number(linea.pacas_al_corte) -
                        Number(linea.pacas_actuales);

                    return (
                        <tr key={linea.pallet_id}>
                            <td className="text-center text-nowrap">
                                {linea.numero}
                            </td>
                            <td className="text-center text-nowrap">
                                <NullableValue
                                    value={linea.identificador_fisico}
                                >
                                    {linea.identificador_fisico || ""}
                                </NullableValue>
                            </td>
                            <td className="text-right text-nowrap">
                                <RenderNumber
                                    value={linea.pacas_actuales}
                                    decimalScale={0}
                                />
                            </td>
                            <td className="text-right text-nowrap">
                                <RenderNumber
                                    value={linea.pacas_al_corte}
                                    decimalScale={0}
                                />
                            </td>
                            <td
                                className={`text-right text-nowrap ${
                                    diferencia !== 0 ? "text-danger" : ""
                                }`}
                            >
                                <RenderNumber
                                    value={diferencia}
                                    decimalScale={0}
                                />
                            </td>
                            <td
                                className={
                                    linea.observaciones ? "" : "text-center"
                                }
                            >
                                <NullableValue value={linea.observaciones}>
                                    {linea.observaciones || ""}
                                </NullableValue>
                            </td>
                            <td className="text-center text-nowrap">
                                <NullableValue value={linea.usuario_nombre}>
                                    <React.Fragment>
                                        {linea.usuario_nombre || ""}
                                        {linea.fecha_modificacion && (
                                            <div className="pacas-al-corte__fecha">
                                                {moment(
                                                    linea.fecha_modificacion,
                                                ).format("DD/MM/YYYY HH:mm")}
                                            </div>
                                        )}
                                    </React.Fragment>
                                </NullableValue>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    </div>
);
